import router from "./router";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import authServices from "@/services/auth";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

router.beforeEach((to, from, next) => {
  window.scroll(0, 0);
  NProgress.start();
  const loginInfo = authServices.loginInfo();
  if (!loginInfo && to.name !== "Login") {
    router.push("/login");
  } else {
    if (!loginInfo && to.meta.auth) {
      router.push({ name: "Forbidden" });
    } else if (loginInfo) {
      if (to.name === "Login") {
        router.push({ name: "Dashboard" });
      }
      next();
    } else {
      next();
    }
  }
  NProgress.done();
});
